// extracted by mini-css-extract-plugin
export default {"message":"_6ee5cfe3b00ed26ae202856b6402f4eb","block":"_91eed48e6ae30ba04f25b646e164c5ed"};